import React, { useEffect, useState, useContext } from "react";
import { utils, writeFile } from "xlsx";
import { BACKEND_API } from "../../../constants/backendApi";

//Style
import "./CancellationProcessBody.css";

//Components
import CreditDetailsTableComponent from "../../CreditDetailsTableComponent/CreditDetailsTableComponent";

//Context
import { LoadingContext } from "../../../context/LoadingContext";
import { PopupContext } from "../../../context/PopupContext";

//hooks
import useDebounce from "../../../hooks/useDebounce";

const CancellationProcessBody = ({ userData }) => {
  const { setLoading } = useContext(LoadingContext);

  const [maxData, setMaxData] = useState(10);

  const [initPage, setInitPage] = useState(0);

  const [creditList, setCreditList] = useState([]);

  const [creditListExcel, setCreditListExcel] = useState([]);

  const [totalCredits, setTotalCredits] = useState(0);

  const [, setTotalCurrentLoans] = useState(0);

  const { setShowPopup, setPopupData } = useContext(PopupContext);

  const [filterData, setFilterData] = useState({
    type: "",
    document_plate: "",
    advisor: "",
    insurer: "",
    credit_state: "",
    next_to_renew: "",
  });

  const tableFields = [
    {
      name: "Altura",
    },
    {
      name: "Nombre Cliente",
    },
    {
      name: "No. de Documento",
    },
    {
      name: "Vigencia Inicial",
    },
    {
      name: "No. de Poliza",
    },
    {
      name: "Placa/Detalle de Riesgo",
    },
    {
      name: "Referencia de Pago en Efecty",
    },
    {
      name: "Valor Cuota",
    },
    {
      name: "Estado",
    },
    {
      name: "Asesor Intermediario",
    },
    {
      name: "Acciones",
    },
  ];

  const token = localStorage.getItem("token");

  useEffect(() => {
    try {
      const selectInsurer = document.getElementById("insurer");

      fetch(`${BACKEND_API}/api/insurance-companies`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then(({ data }) => {
          data.map((insurer) => {
            const option = document.createElement("option");
            option.text = insurer.NombreAseguradora;
            option.value = insurer.IdAseguradora;
            selectInsurer.appendChild(option);

            const optionsArray = Array.from(selectInsurer.options);

            return optionsArray.sort((a, b) => a.text.localeCompare(b.text));
          });
        });
    } catch (err) {
      console.log(err);
    }

    const filterBody = {
      Filtro: filterData.document_plate,
      EstadoConsulta: "",
      IdAseguradora: filterData.insurer,
      Estado: "",
      AllData: true,
      Renovacion: false,
      Cancelados: false,
      EnProcesoCancelacion: true,
      Mora: false,
      EnProceso: false,
      NumeroRegistros: maxData,
      Inicial: initPage,
      Anio: "0",
      Mes: "0",
    };

    try {
      fetch(`${BACKEND_API}/api/credits`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(filterBody),
      })
        .then((res) => res.json())
        .then(({ data }) => {
          if (data.Creditos) {
            setCreditListExcel(data.Creditos);
          } else {
            setCreditList([]);
            setTotalCredits(0);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (err) {
      console.log(err);
    }
  }, [
    filterData?.document_plate,
    filterData?.insurer,
    maxData,
    initPage,
    token,
    setLoading,
  ]);

  const sendCertificate = (creditData) => {
    const body = {
      data: [creditData],
    };

    if (body.data.length !== 0) {
      setLoading(true);
      try {
        fetch(`${BACKEND_API}/api/certificate`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(body),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data && data.message === "Certificados") {
              setShowPopup(true);
              setPopupData({
                title: "Enviado Exitosamente",
                info: `Tu certificado ha sido enviado al siguiente correo electrónico: ${userData.email}`,
                type: "correct",
              });
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (err) {
        console.log(err);
      }
    }
  };

  const downloadCertificate = (creditData) => {
    try {
      fetch(`${BACKEND_API}/api/export-certificate`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(creditData),
      })
        .then(async (res) => {
          if (!res.ok) {
            throw new Error("Error al descargar el certificado");
          }

          const contentType = res.headers.get("Content-Type");
          if (contentType !== "application/pdf") {
            const responseText = await res.text();
            console.error("Respuesta no PDF:", responseText);
            throw new Error(
              `Error: el servidor no devolvió un PDF. Tipo de contenido: ${contentType}`
            );
          }

          return res.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${creditData.tipoDoc}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const debouncedSearch = useDebounce((filterData) => {
    setLoading(true);

    const filterBody = {
      Filtro: filterData.document_plate,
      EstadoConsulta: "",
      IdAseguradora: filterData.insurer,
      Estado: "",
      AllData: false,
      Renovacion: false,
      Cancelados: false,
      EnProcesoCancelacion: true,
      Mora: false,
      EnProceso: false,
      NumeroRegistros: maxData,
      Inicial: initPage,
      Anio: "0",
      Mes: "0",
    };

    if (
      filterData.type === "FiltrosVarios" &&
      filterData.advisor === "" &&
      filterData.insurer === "" &&
      filterData.credit_state === ""
    ) {
      filterBody.TipoFiltro = "";
    }

    try {
      fetch(`${BACKEND_API}/api/credits`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(filterBody),
      })
        .then((res) => res.json())
        .then(({ data }) => {
          if (data && data.Creditos) {
            const creditsNewArr = data.Creditos.map((credit) => [
              {
                field_content: credit.NumCuota + " de " + credit.No_Cuotas,
              },
              {
                field_content: credit.NombreCliente,
              },
              {
                field_content: credit.Document,
              },
              {
                field_content: credit.Inicio_poliza,
              },
              {
                field_content: credit.NoPoliza,
              },
              {
                field_content: credit.Placa
                  ? credit.Placa
                  : credit.detalleRiesgo,
              },
              {
                field_content: credit.CuotasEnProceso
                  ? credit.CuotasEnProceso[0].Referenciadepago
                  : "N/A",
              },
              {
                field_content: credit.CuotasEnProceso
                  ? credit.CuotasEnProceso[0].ValorCuota.toLocaleString(
                      "es-CO",
                      {
                        style: "currency",
                        currency: "COP",
                      }
                    )
                  : "N/A",
              },
              {
                field_content: "Inicio Cancelación - Pagar de Inmediato",
                field_type: "danger",
              },
              {
                field_content: credit.NombreAsesor
                  ? credit.NombreAsesor
                  : "N/A",
              },
              {
                is_action_btn: true,
                btns: [
                  {
                    function: () =>
                      sendCertificate({
                        creditId: credit.credito,
                        clientId: credit.IdClient,
                        nameCertificate: "Recibo_de_pago",
                      }),
                    title: "Enviar Recibo de Pago",
                    icon_src:
                      "https://pagina-crediseguro.s3.amazonaws.com/portal-crediseguro/assets/icons/certification-module-icon-white.webp",
                    icon_src_hover:
                      "https://pagina-crediseguro.s3.amazonaws.com/portal-crediseguro/assets/icons/certification-module-icon.webp",
                  },
                  {
                    function: () =>
                      downloadCertificate({
                        idCredito: credit.IdCredit,
                        tipoDoc: "Recibo_de_pago",
                      }),
                    title: "Descargar Recibo de Pago",
                    icon_src:
                      "https://pagina-crediseguro.s3.us-east-1.amazonaws.com/portal-crediseguro/assets/icons/download-icon-white.webp",
                    icon_src_hover:
                      "https://pagina-crediseguro.s3.us-east-1.amazonaws.com/portal-crediseguro/assets/icons/download-icon.webp",
                  },
                ],
              },
            ]);

            setTotalCurrentLoans(data.TotalCreditosVigentes);
            setTotalCredits(data.TotalRegistros);
            setCreditList(creditsNewArr);
          } else {
            setCreditList([]);
            setTotalCredits(0);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (err) {
      console.log(err);
    }
  }, 500);

  useEffect(() => {
    debouncedSearch(filterData);
    // eslint-disable-next-line
  }, [maxData, initPage, filterData]);

  const getMaxDataValue = (maxDataVal) => {
    setMaxData(maxDataVal);
  };

  const getPaginationData = (initPageVal) => {
    setInitPage(initPageVal);
  };

  const handleGetFilters = (e) => {
    if (e.target.name === "document_plate") {
      setFilterData({
        ...filterData,
        type: e.target.value !== "" ? "Documento_Placa" : "",
        [e.target.name]: e.target.value,
      });
    }

    if (
      e.target.name === "advisor" ||
      e.target.name === "insurer" ||
      e.target.name === "credit_state"
    ) {
      setFilterData({
        ...filterData,
        type: "FiltrosVarios",
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleCleanFilters = () => {
    setFilterData({
      type: "",
      document_plate: "",
      advisor: "",
      insurer: "",
      credit_state: "",
      next_to_renew: "",
    });
  };

  const exportToExcel = () => {
    const jsonData = creditListExcel.map((credit) => {
      return {
        Altura: credit.NumCuota + " de " + credit.No_Cuotas,
        NombreCliente: credit.NombreCliente,
        Aseguradora: credit.Aseguradora,
        NoDocumento: credit.Document,
        DiasMora: credit.DiasMora,
        PlacaDetalleRiesgo: !credit.Placa ? credit.detalleRiesgo : credit.Placa,
        NoPoliza: credit.NoPoliza,
        AsesorIntermediario: credit?.NombreAsesor,
      };
    });

    const workbook = utils.book_new();

    const worksheet = utils.json_to_sheet(jsonData);

    utils.book_append_sheet(
      workbook,
      worksheet,
      "Creditos en proceso cancelacion"
    );

    writeFile(workbook, "Creditos en proceso de cancelación.xlsx");
  };

  return (
    <section className="cancellation-process-section">
      <div className="cancellation-process-subcontainer">
        <div className="cp-title-container">
          <h1 className="cp-title">
            Créditos en Proceso de Cancelación Avisados
          </h1>
        </div>
        <div className="cp-description-txt-container">
          <p className="cpdt-txt">
            Créditos que se encuentran notificados al cliente para la respectiva
            cancelación. Estos créditos se pueden salvar una vez se realice el
            pago inmediato.
          </p>
        </div>
        <div className="filter-elms-container">
          <div className="input-container">
            <form onChange={handleGetFilters} className="filter-form-container">
              <label>
                <h1 className="label-title">Número de Documento o Placa:</h1>
                <input
                  className="filter-input-search"
                  type="text"
                  placeholder="Numero de Documento o Placa"
                  title="Numero de Documento o Placa"
                  name="document_plate"
                  value={filterData.document_plate}
                />
              </label>
              {userData?.profile !== "Aseguradora" && (
                <label>
                  <h1 className="label-title">Aseguradora:</h1>
                  <select
                    name="insurer"
                    id="insurer"
                    disabled={filterData.document_plate !== "" ? true : false}
                    value={filterData.insurer}
                  >
                    <option value="">--Seleccione--</option>
                  </select>
                </label>
              )}
            </form>
            <button
              className="cp-btn-search"
              title="Limpiar Filtros"
              onClick={handleCleanFilters}
            >
              Limpiar Filtros
            </button>
          </div>
        </div>
        <div
          className="cpip-download-excel-container"
          style={{ display: creditList.length > 0 ? "unset" : "none" }}
        >
          <button
            title="Descargar Excel"
            className="cpip-de-btn"
            onClick={() => exportToExcel()}
          >
            Descargar Excel
          </button>
        </div>
        <div className="credit-details-table-supercontainer">
          <CreditDetailsTableComponent
            getMaxData={getMaxDataValue}
            maxData={maxData}
            getPaginationInit={getPaginationData}
            credits={creditList}
            totalCreditsNum={totalCredits}
            filterData={filterData}
            fields={tableFields}
          />
        </div>
      </div>
    </section>
  );
};

export default CancellationProcessBody;
